module.exports = __webpack_public_path__ + "static/media/setting.4476464c.svg";